import styles from './TopStaffWidget.module.scss'
import api from 'helpers/api'
import { useEffect, useState } from 'react'
import { ResponsivePieCanvas } from '@nivo/pie'
import moment from 'moment';
import Loader from 'components/miscellaneous/Loader/Loader';
import { sortBy, take, sumBy } from "lodash";
import { FaChartPie } from 'react-icons/fa'

const TopStaffWidget = ({ dateRange, stack, small }) => {
    const { startDate, endDate } = dateRange;
    const [ data, setData ] = useState(null);
    const [ isLoaded, setIsLoaded ] = useState(false);

    useEffect(() => {
        if (isLoaded === true) {
            setIsLoaded(false)
        }

        getData().then(res => {
            const graphData = res.map((item) => {
                return {
                    realId: item.id,
                    id: item.name,
                    label: item.name,
                    value: item.numberOfTreatments
                }
            })

            //console.log(graphData)

            const top5 = take(sortBy(graphData, 'numberOfTreatments').reverse(), 5);
            const others= graphData.filter(s => top5.find(ts => ts.realId === s.realId) === undefined)
            const allData = [
                ...top5,
                {
                    id: `Others`,
                    label: `Others  (${others.length} Staff)`,
                    value: sumBy(others, 'value')
                }
            ]
            setData(allData)
        }).catch(e => {
            console.error(e)
        })
    }, [ dateRange ])

    useEffect(() => {
        if (data !== null) {
            setIsLoaded(true)
        }
    }, [ data ])


    const getData = async () => {
        const data = await api.get(`dashboard/staff/top?startDate=${startDate}&endDate=${endDate}`)
        return data.data.data;
    }

    const getWidgetClass = () => {
        const classes = [styles.topStaffWidget]
        if(stack) {
            classes.push(styles.topStaffWidgetStack)
        }

        if(small) {
            classes.push(styles.topStaffWidgetSmall)
        }

        return classes.join(' ')
    }

    return (<div style={ { width: '100%', height: '100%', minHeight: 200 } } className="d-flex">
        { isLoaded ? 
            <>
            {sumBy(data, 'value') > 0 ? <div className={getWidgetClass()}>
            <div className={styles.topStaffList}>
                {sortBy(data.filter(s => s.value > -1), 'value').reverse().map((s, i) => {
                    const num = i + 1;
                    
                    if(num <= 3) {
                        return (
                            <div className={styles.staffRow}>
                                <div>{num}. {s.id}</div>
                                <div className={styles.staffTreatments}>{s.value} Sessions</div>
                            </div>
                        )
                    }
                })}
            </div>
            <div className={styles.canvas}>
            <ResponsivePieCanvas
                width={200}
                data={ data }
                margin={ { top: 20, right: 0, bottom: 20, left: 0 } }
                innerRadius={ 0.6 }
                padAngle={ 0.7 }
                activeOuterRadiusOffset={ 8 }
                colors={[
                    '#93d5ed',
                    '#5c9ceb',
                    '#2e7de4',
                    '#1d5ba6',
                ]}
                tooltip={ point => {
                    return <div style={ {
                        background: '#fff',
                        padding: '10px',
                        borderRadius: '5px',
                        boxShadow: '0 1px 2px rgba(0, 0, 0, 0.25)',
                    } }>{point.datum.label} - {point.datum.value} Treatments</div>;
                } }
                arcLabel="id"
                borderColor="#000000"
                enableArcLinkLabels={ false }
                arcLinkLabelsSkipAngle={ 10 }
                arcLinkLabelsTextColor="#fff"
                arcLinkLabelsThickness={ 2 }
                arcLinkLabelsColor={ { from: 'color' } }
                arcLabelsSkipAngle={ 10 }
                arcLabelsTextColor="#fff"
            />
            </div>
            </div> : <div className={ `${styles.noData}` }>
            <FaChartPie />
            No data
        </div> }
                </>  : <div style={ { margin: 'auto' } }><Loader color="#ddd"></Loader></div> }
    </div>)
}


export default TopStaffWidget;